import React from "react";
import { Link } from "react-router-dom";
import AWS from "aws-sdk";
import ReactPlayer from "react-player";
import { CircularProgress } from "@material-ui/core";
import successimg from "../../assets/images/successimg.png";
import userService from "../../services/user.service";
// Component
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Material UI
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
//Assets
import plusIcon from "../../assets/images/plusIcon.png";
import stream from "../../assets/images/stream.svg";
import close from "../../assets/images/crosstick.png";
import cameraConnected from "../../assets/images/cameraConnected.png";
import {
  setInToLocalStorage,
  getFromLocalStorage,
} from "../../utils/webStorage";
import { BsXLg } from "react-icons/bs";

var finalUrlSend;
var finalUrlSend1;
class Camera extends React.Component {
  state = {
    anchorEl: null,
    streamUrlKinesis: "",
    streamUrlKinesis1: "",
    submitting: false,
    duration: null,
    secondsElapsed: null,
    eventId: "",
    category: "",
    playlistName: "",
    playlistIdToSend: "",
    schoolId: "",
    mediaFileArr: [],
    files: [],
    streamPlay: false,
    streamPlay1: false,
    count: 0,
    startStop: "START",
    eventNameShow: "",
    clipCount: 0,
    team1: "",
    team2: "",
    cameraAngles: [
      { id: 0, name: "EndZoneR", status: false },
      { id: 1, name: "WideAngle", status: false },
      { id: 2, name: "Tight", status: false },
      { id: 3, name: "EndZoneL", status: false },
      { id: 4, name: "Other", status: false },
    ],
    selectedCameraAngle1: "",
    selectedCameraAngle2: "",
    selectedCameraAngle3: "",
    selectedCameraAngle4: "",
    selectedCameraAngle5: "",
    selectedCameraAngle: "",
    streamStatus: false,
    streamStatus1: false,
  };

  onDuration = (duration) => {
    this.setState({ duration });
  };
  onProgress = (progress) => {
    if (!this.state.duration) {
      // Sadly we don't have the duration yet so we can't do anything
      return;
    }
    // progress.played is the fraction of the video that has been played
    // so multiply with duration to get number of seconds elapsed
    // const secondsElapsed = progress.played * this.state.duration
    var testSend = Math.trunc(progress.playedSeconds);
    var secondsElapsed = testSend;
    this.setState({ secondsElapsed });
    // console.log("duration",this.state.duration)
    console.log("progress", Math.trunc(progress.playedSeconds));
    // if (secondsElapsed !== this.state.secondsElapsed) {
    //   this.setState({ secondsElapsed })
    // }
  };

  componentDidMount() {
    var eventId = getFromLocalStorage("eventIdSelectedCamera");
    var schoolId = getFromLocalStorage("schoolId");
    this.setState({ eventId, schoolId });
    this.getEventById(eventId);
    this.activateKinesis();
    this.activateKinesis1();
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  //
  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  activateKinesis() {
    var streamName = "thzstream";
    // Step 1: Configure SDK Clients
    var options = {
      accessKeyId: "AKIAQLCFTPFIMFAPFUN4",
      secretAccessKey: "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",
      region: "us-east-2",
    };
    var kinesisVideo = new AWS.KinesisVideo(options);
    var kinesisVideoArchivedContent = new AWS.KinesisVideoArchivedMedia(
      options
    );

    // Step 2: Get a data endpoint for the stream
    kinesisVideo.getDataEndpoint(
      {
        StreamName: streamName,
        APIName: "GET_HLS_STREAMING_SESSION_URL",
      },
      function (err, response) {
        if (err) {
          return console.error(err);
        }
        console.log("Data endpoint: " + response.DataEndpoint);
        kinesisVideoArchivedContent.endpoint = new AWS.Endpoint(
          response.DataEndpoint
        );

        // Step 3: Get an HLS Streaming Session URL
        console.log("Fetching HLS Streaming Session URL");
        var playbackMode = "LIVE"; // 'LIVE' or 'ON_DEMAND'
        //var startTimestamp = new Date('START_TIMESTAMP'); // For ON_DEMAND only
        //var endTimestamp = new Date('END_TIMESTAMP'); // For ON_DEMAND only
        var fragmentSelectorType = "SERVER_TIMESTAMP"; // 'SERVER_TIMESTAMP' or 'PRODUCER_TIMESTAMP'
        const SESSION_EXPIRATION_SECONDS = 60 * 60;
        const hlsUrl = kinesisVideoArchivedContent.getHLSStreamingSessionURL(
          {
            StreamName: streamName,
            //StreamARN: "arn:aws:kinesisvideo:us-east-1:635420739373:stream/mr-pinchers-dot-org/1561848963391",
            PlaybackMode: playbackMode,
            HLSFragmentSelector: {
              FragmentSelectorType: fragmentSelectorType,
              TimestampRange:
                playbackMode === "LIVE"
                  ? undefined
                  : {
                      //            StartTimestamp: startTimestamp,
                      //            EndTimestamp: endTimestamp
                    },
            },
            Expires: parseInt(SESSION_EXPIRATION_SECONDS),
          },
          function (err, response) {
            if (err) {
              return console.error("Darn", err);
            }
            console.log(
              "HLS Streaming Session URL: " + response.HLSStreamingSessionURL,
              response
            );
            this.finalUrlSend = response.HLSStreamingSessionURL;
            setInToLocalStorage("streamUrlKinesis", this.finalUrlSend);
          }
        );
      }
    );
    var streamUrlKinesis = getFromLocalStorage("streamUrlKinesis");
    console.log(streamUrlKinesis);
    this.setState({ streamUrlKinesis });
    if (streamUrlKinesis == null) {
      var streamStatus = true;
      this.setState({ streamStatus });
    } else {
      var streamStatus = false;
      this.setState({ streamStatus });
    }
  }

  activateKinesis1() {
    var streamName = "mystream";
    // Step 1: Configure SDK Clients
    var options = {
      accessKeyId: "AKIAQLCFTPFIMFAPFUN4",
      secretAccessKey: "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",
      region: "us-east-2",
    };
    var kinesisVideo = new AWS.KinesisVideo(options);
    var kinesisVideoArchivedContent = new AWS.KinesisVideoArchivedMedia(
      options
    );

    // Step 2: Get a data endpoint for the stream
    kinesisVideo.getDataEndpoint(
      {
        StreamName: streamName,
        APIName: "GET_HLS_STREAMING_SESSION_URL",
      },
      function (err, response) {
        if (err) {
          return console.error(err);
        }
        console.log("Data endpoint: " + response.DataEndpoint);
        kinesisVideoArchivedContent.endpoint = new AWS.Endpoint(
          response.DataEndpoint
        );

        // Step 3: Get an HLS Streaming Session URL
        console.log("Fetching HLS Streaming Session URL");
        var playbackMode = "LIVE"; // 'LIVE' or 'ON_DEMAND'
        //var startTimestamp = new Date('START_TIMESTAMP'); // For ON_DEMAND only
        //var endTimestamp = new Date('END_TIMESTAMP'); // For ON_DEMAND only
        var fragmentSelectorType = "SERVER_TIMESTAMP"; // 'SERVER_TIMESTAMP' or 'PRODUCER_TIMESTAMP'
        const SESSION_EXPIRATION_SECONDS = 60 * 60;
        const hlsUrl = kinesisVideoArchivedContent.getHLSStreamingSessionURL(
          {
            StreamName: streamName,
            //StreamARN: "arn:aws:kinesisvideo:us-east-1:635420739373:stream/mr-pinchers-dot-org/1561848963391",
            PlaybackMode: playbackMode,
            HLSFragmentSelector: {
              FragmentSelectorType: fragmentSelectorType,
              TimestampRange:
                playbackMode === "LIVE"
                  ? undefined
                  : {
                      //            StartTimestamp: startTimestamp,
                      //            EndTimestamp: endTimestamp
                    },
            },
            Expires: parseInt(SESSION_EXPIRATION_SECONDS),
          },
          function (err, response) {
            if (err) {
              return console.error("Darn", err);
            }
            console.log(
              "HLS Streaming Session URL: " + response.HLSStreamingSessionURL,
              response
            );
            this.finalUrlSend1 = response.HLSStreamingSessionURL;
            setInToLocalStorage("streamUrlKinesis1", this.finalUrlSend1);
          }
        );
      }
    );

    var streamUrlKinesis1 = getFromLocalStorage("streamUrlKinesis1");
    console.log(streamUrlKinesis1);
    this.setState({ streamUrlKinesis1 });
    if (streamUrlKinesis1 == null) {
      var streamStatus1 = true;
      this.setState({ streamStatus1 });
    } else {
      var streamStatus1 = false;
      this.setState({ streamStatus1 });
    }
  }

  openDialogVideoSuccess() {
    this.setState({
      openVideoDeleteSuccess: !this.state.openVideoDeleteSuccess,
    });
  }

  closeDialogVideoSuccess() {
    this.setState({
      openVideoDeleteSuccess: !this.state.openVideoDeleteSuccess,
    });
  }

  openDialogVideoSuccess1() {
    this.setState({
      openVideoDeleteSuccess1: !this.state.openVideoDeleteSuccess1,
    });
  }

  closeDialogVideoSuccess1() {
    this.setState({
      openVideoDeleteSuccess1: !this.state.openVideoDeleteSuccess1,
    });
  }

  getEventById(eventId) {
    userService
      .getEventDetailsEdit(eventId)
      .then((response) => {
        if (response.data.data.eventType == "Game") {
          var category = 1;
          this.setState({ category });
        }
        if (response.data.data.eventType == "Practice") {
          var category = 3;
          this.setState({ category });
        }
        if (response.data.data.eventType == "Scout") {
          var category = 2;
          this.setState({ category });
        }
        var eventNameShow = response.data.data.eventName;
        var playlistName = response.data.data.eventName;
        this.setState({ eventNameShow, playlistName });

        if (response.data.data.team1 != null) {
          var team1 = response.data.data.team1.teamName;
          this.setState({ team1 });
        }
        if (response.data.data.team2 != null) {
          var team2 = response.data.data.team2.teamName;
          this.setState({ team2 });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  downloadClipApi = () => {
    var url = this.state.streamUrlKinesis;
    var startTime = "00:00:00";
    var duration = this.state.secondsElapsed;
    var submitting = true;
    this.setState({ submitting });
    userService.localKinesisStreamSave(url, startTime, duration).then((res) => {
      var files = res.data.data;
      var submitting = false;
      this.setState({ submitting, files });
      this.openDialogVideoSuccess();
    });
  };

  saveEvent() {
    this.closeDialogVideoSuccess();
    var submitting = true;
    this.setState({ submitting });
    const {
      category,
      eventId,
      playlistName,
      schoolId,
      playlistIdToSend,
      mediaFileArr,
      files,
    } = this.state;

    userService
      .saveEventFromStream(
        category,
        eventId,
        mediaFileArr,
        playlistName,
        schoolId,
        playlistIdToSend,
        [files]
      )
      .then((response) => {
        if (response.status === 200) {
          var submitting = false;
          var clipCount = this.state.clipCount + 1;
          this.setState({ submitting, clipCount });
          this.openDialogVideoSuccess1();
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  // stopStreamPlay(){
  //   var streamPlay = false;
  //   this.setState({streamPlay})
  // }

  testCheck() {
    if (this.state.startStop == "START") {
      var startStop = "STOP";
      var streamPlay = true;
      this.setState({ startStop, streamPlay });
    } else {
      var startStop = "START";
      var streamPlay = false;
      this.setState({ startStop, streamPlay });
      this.downloadClipApi();
    }
  }

  App = () => (
    //ENDZONER
    <ReactPlayer
      id="videoPlayer2"
      className="videoPlayer1"
      url={this.state.streamUrlKinesis}
      playing={this.state.streamPlay}
      controls
      className="img-fluid video1"
      alt="EZ"
      onDuration={this.onDuration}
      onProgress={this.onProgress}
    />
  );

  App1 = () => (
    //ENDZONER
    <ReactPlayer
      id="videoPlayer2"
      className="videoPlayer1"
      url={this.state.streamUrlKinesis1}
      playing={this.state.streamPlay1}
      controls
      className="img-fluid video1"
      alt="EZ"
    />
  );

  render() {
    const {
      submitting,
      eventNameShow,
      team1,
      team2,
      clipCount,
      cameraAngles,
      streamStatus,
      streamStatus1,
    } = this.state;
    return (
      <div className={submitting ? "gray-out" : " "}>
        <SchoolAdminDashboard />
        <div className="clear60"></div>

        <div className="row">
          <div className="col-md-6 collg-6 plr">
            <div className="clear20"></div>
            <span className="fs-20 semi-bold dblack">Active cameras</span>
            &nbsp;&nbsp;
            <span className="fs-20 semi-bold dblack">4*20</span>&nbsp;&nbsp;
            <span className="fs-20 semi-bold dblack">
              Total Clips : {clipCount}
            </span>
            <div className="clear5"></div>
            <div className="col-md-12 col-lg-12">
              <span className="fs-16 semibold">
                {team1} vs {team2} | {eventNameShow}
              </span>
              &nbsp;&nbsp;&nbsp;
              {/* <span className="fs-16 semibold skyblue cp">End this session</span> */}
            </div>
            {/* <button
                              type="button"
                              class="cancelbtn"
                              onClick={() => {
                                this.downloadClipApi()
                               }}
                            >
                              Download
                            </button> */}
          </div>
          <div className="col-md-6 collg-6 plr text-right">
            {/* <div className="clear20"></div> */}
            {/* <div class="onoffswitch mr-4 float-right">
    <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox fs-40 bold regular white" id="myonoffswitch" />
    <label class="onoffswitch-label" for="myonoffswitch">
        <span class="onoffswitch-inner" onClick={() => {this.testCheck()}}></span>
        <span class="onoffswitch-switch"></span>
    </label>
</div> */}
            <div className="col-lg-12">
              <div className="p-20 text-right">
                <button
                  type="submit"
                  disabled={streamStatus == true}
                  className={
                    this.state.startStop == "START"
                      ? "liveCamBtn"
                      : "liveCamBtn1"
                  }
                  onClick={() => {
                    this.testCheck();
                  }}
                >
                  {this.state.startStop}
                </button>
                {/* {
                      <button type="submit" disabled={streamStatus==true} className={this.state.startStop=="START" ? "liveCamBtn" : "liveCamBtn1"} onClick={() => {this.testCheck()}}>{this.state.startStop}</button>
                      } */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="clear5"></div> */}
        <div className="row">
          <div className="col-md-4 col-lg-4 brDa cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                {!streamStatus && (
                  <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                    {this.App()}{" "}
                    {/* <img className="img-fluid h280" src={cameraConnected} alt="plus" />             */}
                  </div>
                )}
                {streamStatus && (
                  <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                    {/* <img className="img-fluid h280" src={cameraConnected} alt="plus" />             */}
                    <div className="clear60"></div>
                    <div className="clear30"></div>
                    <span className="fs-16 regular dblack">
                      No Live Stream available currently
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 brDa cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle1}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle1: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                {!streamStatus1 && (
                  <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                    {this.App1()}{" "}
                    {/* <img className="img-fluid h280" src={cameraConnected} alt="plus" />             */}
                  </div>
                )}
                {streamStatus1 && (
                  <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                    {/* <img className="img-fluid h280" src={cameraConnected} alt="plus" />             */}
                    <div className="clear60"></div>
                    <div className="clear30"></div>
                    <span className="fs-16 regular dblack">
                      No Live Stream available currently
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle2}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle2: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                  <div className="clear60"></div>
                  {/* <img src={plusIcon} alt="plus" />             */}
                  <div className="clear30"></div>
                  <span className="fs-16 regular dblack">
                    No Live Stream available currently
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-lg-4 brDa cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle3}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle3: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                  <div className="clear60"></div>
                  {/* <img src={plusIcon} alt="plus" />             */}
                  <div className="clear30"></div>
                  <span className="fs-16 regular dblack">
                    No Live Stream available currently
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 brDa cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle4}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle4: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                  <div className="clear60"></div>
                  {/* <img src={plusIcon} alt="plus" />             */}
                  <div className="clear30"></div>
                  <span className="fs-16 regular dblack">
                    No Live Stream available currently
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 brbottom cp">
            <div className="col-md-12 col-lg-12 ">
              <select
                class="form-control fs-16 regular dblack bgE3 olnone brnone"
                id="sel1"
                value={this.state.selectedCameraAngle5}
                onChange={(event) => {
                  this.setState({
                    selectedCameraAngle5: event.target.value,
                  });
                }}
              >
                <option>Select Camera Angle</option>
                {Array.isArray(cameraAngles) && cameraAngles.length > 0
                  ? cameraAngles.map((item) => {
                      return <option key={item.name}>{item.name}</option>;
                    })
                  : null}
              </select>
              <div className="col-12 col-md-12 col-lg-12 campad">
                <div className="col-md-12 col-lg-12 cam-box-style text-center h210">
                  <div className="clear60"></div>
                  {/* <img src={plusIcon} alt="plus" />             */}
                  <div className="clear30"></div>
                  <span className="fs-16 regular dblack">
                    No Live Stream available currently
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Dialog
          id="dialogBoxcameras"
          className="camera-dialogone"
          open={this.state.open}
          onClose={this.closeDialog.bind(this)}
        >
          <DialogTitle className="bgwhite">
            <div className="row">
              <div className="col-md-6 col-lg-6 mx-auto">
                <img src={stream} alt="cam"></img>&nbsp;&nbsp;
                <span className="fs-18 regular txt43">Connect Camera</span>
              </div>
              <div className="col-1 text-right ml-auto mr-4">
                <BsXLg
                  onClick={this.closeDialog.bind(this)}
                  className="crossview cp"
                ></BsXLg>
              </div>
            </div>
          </DialogTitle>
          <DialogContent className="bgwhite">
            <div className="clear10"></div>
            <div className="row">
              <div className="col-md-6 col-lg-6 mx-auto text-center">
                <p className="fs-20 semi-bold text-center">
                  Enter Camera IP Address
                </p>
                <div className="clear10"></div>
                <input
                  type="text"
                  className="inputstyle h40 olnone w-100"
                  placeholder="Enter IP address"
                ></input>
                <div className="clear20"></div>
                <span className="fs-16 regular">Select Angle</span>
                <div className="clear10"></div>
              </div>

              <div className="cleac20"></div>
            </div>
            <div className="clear10"></div>
            <div className="row">
              <div className="col-md-6 col-lg-6 mx-auto text-center">
                <select class="form-control fs-16 regular olnone" id="sel1">
                  <option>Select</option>
                  <option>Angle 1</option>
                  <option>Angle 2</option>
                  <option>Angle 3</option>
                </select>
              </div>
            </div>
            <div className="clear20"></div>
            <div className="row">
              <div className="col-5 col-md-6 col-lg-6 mx-auto text-center ">
                <Link to="/cameras">
                  <button
                    type="button"
                    class="req-con-btn h40 mx-auto d-flex align-items-center justify-content-center"
                  >
                    Request Connection
                  </button>
                </Link>
              </div>
            </div>
            <div className="clear20"></div>
            <div className="row">
              <div className="col-5 col-md-6 col-lg-6 mx-auto text-center">
                <button
                  type="button"
                  class="cancelbtn"
                  onClick={this.closeDialog.bind(this)}
                >
                  Close
                </button>
              </div>
            </div>
            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        <Dialog
          id="dialogBoxUpdateEvent"
          className="dialog-style"
          open={this.state.openVideoDeleteSuccess}
          onClose={this.closeDialogVideoSuccess.bind(this)}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto ">
                <BsXLg
                  onClick={this.closeDialogVideoSuccess.bind(this)}
                  className="crossview cp"
                ></BsXLg>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new mb-3"
                ></img>
                <p className="fs-20 semi-bold text-center mb-4 updatemsg">
                  Video clipped and saved successfully{" "}
                </p>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                <button
                  type="button"
                  class="donebtn"
                  onClick={() => {
                    this.saveEvent();
                  }}
                >
                  DONE
                </button>
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        <Dialog
          id="dialogBoxUpdateEvent"
          className="dialog-style"
          open={this.state.openVideoDeleteSuccess1}
          onClose={this.closeDialogVideoSuccess1.bind(this)}
        >
          <DialogTitle>
            <div className="row">
              <div className="col-1 text-right ml-auto ">
                <BsXLg
                  onClick={this.closeDialogVideoSuccess1.bind(this)}
                  className="crossview cp"
                ></BsXLg>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 text-center">
                <img
                  src={successimg}
                  alt="success"
                  className="successimg-new mb-3"
                ></img>
                <p className="fs-20 semi-bold text-center mb-4 updatemsg">
                  clipped Video successfully attached to {eventNameShow}
                </p>
              </div>
              <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                <button
                  type="button"
                  class="donebtn"
                  onClick={this.closeDialogVideoSuccess1.bind(this)}
                >
                  DONE
                </button>
              </div>
            </div>

            <div className="clear10"></div>

            <div className="clear10"></div>
          </DialogContent>
        </Dialog>

        {submitting && (
          <CircularProgress
            style={{
              width: "45px",
              height: "44px",
              position: "absolute",
              left: "48%",
              top: "47%",
              zIndex: "99",
            }}
            color="secondary"
          />
        )}
      </div>
    );
  }
}

export default Camera;
